import Axios from 'axios'
import notify from 'devextreme/ui/notify'

const URL = 'api/system/items'

export default {
    namespaced: true,
    state: {
        items: [],
        categories: [],
        showActive: true
    },
    mutations: {
        setItems(state, itm) {
            state.items = itm ? itm : []
        },
        setCats(state, cats) {
            state.categories = cats ? cats : []
        },
        setStat(state, stat = true) {
            debugger
            state.showActive = stat;
        }
    },
    actions: {
        loadInactive({ commit }, active = true) {
            commit('setStat', active);

            return this.dispatch('sysItems/getItems');
        },
        getItems({ commit, state }) {

            this.dispatch('updateStat', true)

            var active = state.showActive ? 1 : 0;

            return Axios.get(URL + '?active=' + active)
                .then(response => {
                    commit('setItems', response.data.items)
                    commit('setCats', response.data.categories)
                    return this.dispatch('updateStat', false)

                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    return this.dispatch('updateStat', false)
                })
        },
        addItem({ commit }, itm) {
            this.dispatch('updateStat', true)

            return Axios.post(URL, itm)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'
                    var msg = type === 'success' ? 'Item was added.' : response.data.msg;

                    notify(msg, type, 4000);

                    this.dispatch('updateStat', false)
                        .then(() => type === 'success')

                    return response.data.success;
                })
                .then(rsp => {
                    return this.dispatch('sysItems/getItems')
                        .then(() => rsp);
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    this.dispatch('updateStat', false)
                    return false;
                })
        },
        updateItem({ commit }, itm) {
            this.dispatch('updateStat', true)

            return Axios.put(URL + '?id=' + itm.id, itm)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'
                    var msg = type === 'success' ? 'Item was updated.' : response.data.msg;

                    notify(msg, type, 4000);

                    return this.dispatch('updateStat', false)
                        .then(() => response.data.success)
                })
                .then(rsp => {
                    return this.dispatch('sysItems/getItems')
                        .then(gotItems => rsp);
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    this.dispatch('updateStat', false)
                    return false;
                })
        },
        removeItem({ commit }, id) {
            ;
            this.dispatch('updateStat', true)
            if (!id) {
                return this.dispatch('updateStat', false)

            }
            return Axios.delete(URL + '?id=' + id.toString())
                .then(response => {

                    var type = response.data.success ? 'success' : 'error'
                    var msg = response.data.msg;

                    return this.dispatch('sysItems/getItems')
                        .then(() => {
                            notify(msg, type, 4000)
                            return response.data.success;
                        })
                })
        }
    },
    getters: {
        items: state => state.items,
        categories: state => state.categories,
        showActive: state => state.showActive
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/LinkDSG/dsgItems.js